<template>
	<div class="routineloginBox">
		<div class="common-header-wrap">
			<mt-header class="common-header" title="Login">
				<mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
				<mt-button slot="right" @click="onSignup">Register</mt-button>
			</mt-header>
		</div>
		<div class="wxcodebox" v-if="wxloginshow">
			<div class="dypligobox">
				<img src="../../../assets/image/dyplogo.png" alt="DYP Mall" title="DYP Mall" />
			</div>
			<div class="loginbottomBox">
				<div class="wxloginbottom" @click="onWechat">
					<img src="../../../assets/image/wxlcon.png" />WeChat authorized login
				</div>
				<div v-if="codephonelogin" class="phoneloginbottom" @click="phonelogin">Phone Number Login</div>
			</div>
		</div>


		<div class="routinelogins" v-if="phoneloginbox">
			<div class="container">
				<div class="topList">
					<div class="list">
						<div class="item" v-for="(item, index) in items" :key="index" v-on:click="onClickItem(index)">
							<label class="title" v-bind:class="{
					active: index === currentIndex,
					normal: index !== currentIndex
				}">{{ getTitle(item) }}</label>
							<div class="line" v-if="isShowLine(index)"></div>
						</div>
					</div>
				</div>
				<div class="top-wrapper">
					<mt-field v-if="currentIndex === 0" class="input-wrapper" v-model="username"
						placeholder="Member ID/Email/Mobile" type="text"></mt-field>
					<mt-field v-if="currentIndex !== 0" class="input-wrapper" v-model="mobileusername"
						placeholder="Please fill in Mobile Number"
						:attr="{oninput: 'if(value.length>11)value=value.slice(0,11)'}" type="text"></mt-field>
					
					
					
					
					<mt-field v-if="currentIndex === 0" class="input-wrapper" type="password" v-model="password"
						placeholder="Password">
					</mt-field>
					<mt-field v-if="currentIndex === 0 && config.captcha_status_login=='1'" class="input-wrapper"
						v-model="pictureCode" placeholder="Verification Code" maxlength="6">
						<img @click="changePictureCode" :src="pictureCodeUrl" class="countdown">
					</mt-field>
					<mt-field v-if="currentIndex !== 0" class="input-wrapper" v-model="code"
						placeholder="Please enter SMS code" type="number"
						:attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }">
						
						
						
						<mt-button @click="sendVerifyCodeMobile" class="countdown" type="default" size="small"
							plain>{{sendStateTextMobile}}</mt-button>
					</mt-field>
				</div>
				<mt-button type="primary" class="ds-button-large mt-10 mb-10" v-on:click="signin">Login</mt-button>
				<div class="retrieve-wrapper">
					<div class="retrieve-item" @click="onRetrieve">
						<label id="retrieve-title">Forgot password?</label>
					</div>
				</div>
				<div class="bottom-wrapper" v-if="isShowWechat || isShowSina || isShowQQ">
					<div class="auth-title-wrapper">
						<div class="auth-line"></div>
						<label class="auth-title">Third-party login</label>
						<div class="auth-line"></div>
					</div>
					<div class="auth-bottom-wrapper">
						<div class="auth-item" v-if="isShowWechat" @click="onWechat">
							<i class="auth-item-icon iconfont wechat">&#xe647;</i>
							<label class="auth-title auth-item-title">WeChat</label>
						</div>
						<div class="auth-item" v-if="isShowSina" @click="onSina">
							<i class="auth-item-icon iconfont sina">&#xe646;</i>
							<label class="auth-title auth-item-title">M-bBog</label>
						</div>
						<div class="auth-item" v-if="isShowQQ" @click="onTencent">
							<i class="auth-item-icon iconfont tencent">&#xe882;</i>
							<label class="auth-title auth-item-title">QQ</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		login,
		wechatLogin,
		LoginByMobile,
		getThirdLogin
	} from '../../../api/memberLogin'
	import {
		isWechat
	} from '../../../util/wechat'
	import {
		loadScript
	} from '../../../util/common'
	import {
		getSmsCaptcha,
		checkPictureCaptcha
	} from '../../../api/common'
	import {
		Indicator,
		Toast
	} from 'mint-ui'
	import {
		mapMutations,
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'Login',
		data() {
			return {
				ifLoaded: false,
				uniapp: 0,
				pictureCodeUrl: '',
				pictureCode: '',
				code: '',
				verifyCodeMobile: '',
				canSendMobile: true,
				timeIntervalMobile: false,
				sendStateTextMobile: 'Send',
				mobileusername: '',
				username: '',
				password: '',
				currentIndex: 0,
				wxloginshow: false,
				phoneloginbox: true,
				codephonelogin: true,
				loginurl: '',
				redirecturl: '',
				items: [{
						id: 1,
						title: 'Login'
					}
					//      ,{
					//        id: 2,
					//        title: 'Mobile login'
					//      }

				]
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				// 通过 `vm` 访问组件实例
				vm.utils.setCookie('referrer', encodeURIComponent(from.fullPath), 1 / 24)
			})
		},
		computed: {
			...mapState({
				inviter_id: state => state.member.inviterId,
				config: state => state.config.config
			}),
			isShowWechat: function() {
				if ((isWechat() || this.uniapp) && this.config && this.config.weixin_isuse == 1) {
					this.wxloginshow = true;
					this.phoneloginbox = false;
					return true

				}
				return false
			},
			isShowSina: function() {
				if (!isWechat() && !this.uniapp && this.config && this.config.sina_isuse == 1) {
					return true
				}
				return false
			},
			isShowQQ: function() {
				if (!isWechat() && !this.uniapp && this.config && this.config.qq_isuse == 1) {
					return true
				}
				return false
			}
		},
		watch: {
			mobileusername(newVal, oldVal) {
				newVal = newVal.replace(/[^\d]/g, '')
				if (!newVal) {
					this.$nextTick(() => {
						this.mobileusername = newVal
					})
				}
			}
		},
		beforeDestroy: function() {
			clearInterval(this.timeIntervalMobile)
		},
		created: function() {
			this.redirecturl = this.$route.query.redirecturl;
			this.loginurl = this.$route.query.urls;
			let _this = this
			loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function() {
				_this.ifLoaded = true
			})
			Indicator.close()
			getThirdLogin().then(res => {
				let user_info = res.result.user_info
				let key = res.result.key
				if (user_info && key) {
					this.saveAuthInfo({
						token: key,
						info: user_info
					})
					this.goHome()
				}
			})

			if (this.$route.query.clear) {
				this.memberLogout()
			}
			this.fetchConfig({}).then(
				response => {},
				error => {
					Toast(error.message)
				}
			)

			//clear==2时，只显示微信登录
			var clears = this.$route.query.clear;
			if (clears == "2") {
				this.codephonelogin = false;
				this.wxloginshow = true;
				this.phoneloginbox = false;
			}
		},
		mounted() {
			let isTokenInvalid = this.$route.params.isTokenInvalid
			if (isTokenInvalid) {
				Toast('Expiration')
			}
			this.changePictureCode()
		},
		methods: {
			...mapMutations({
				saveAuthInfo: 'memberLogin',
				saveSellerAuthInfo: 'sellerLogin',
				memberLogout: 'memberLogout'
			}),
			...mapActions({
				fetchConfig: 'fetchConfig'
			}),
			phonelogin() {
				this.phoneloginbox = true;
				this.wxloginshow = false;
				this.onClickItem(1)
			},
			changePictureCode() {
				this.pictureCodeUrl = env.API_HOST + '/Seccode/makecode?r=' + Math.random()
			},
			sendVerifyCodeMobile() {
				if (!this.mobileusername) {
					Toast('请先输入手机号')
					return
				}
				if (!this.canSendMobile) {
					return
				}
				getSmsCaptcha(2, this.mobileusername).then(res => {
					this.canSendMobile = false
					let second = 60
					Toast(res.message)
					let _this = this
					this.timeIntervalMobile = setInterval(function() {
						if (second <= 0) {
							_this.canSendMobile = true
							_this.sendStateTextMobile = '发送'
							clearInterval(_this.timeIntervalMobile)
						} else {
							_this.sendStateTextMobile = second + 's'
						}
						second--
					}, 1000)
				}).catch(function(error) {
					Toast(error.message)
				})
			},
			getTitle(item) {
				return item ? item.title : ''
			},
			isShowLine(index) {
				return index === this.currentIndex
			},
			onClickItem(index) {
				if (this.currentIndex !== index) {
					this.currentIndex = index
				}
			},
			onTencent() {
				window.location.href = env.API_HOST + '/api/oa_qq'
			},
			onSina() {
				window.location.href = env.API_HOST + '/api/oa_sina'
			},
			signin() {
				if (this.currentIndex == 0) {
					let username = this.username
					let password = this.password
					if (username.length === 0) {
						Toast('Please enter ID/Email/Mobile')
						return
					}
					// TODO: 用户名（为手机号或邮箱）校验
					if (password.length === 0) {
						Toast('Please enter password')
						return
					}
					if (password.length < 6) {
						Toast('Password of at least 6 digits')
						return
					}
					Indicator.open()
					login(username, password, this.pictureCode).then(
						response => {
							Indicator.close()
							this.saveAuthInfo({
								token: response.result.token,
								info: response.result.info
							})
							if (response.result.seller_info) {
								this.saveSellerAuthInfo({
									token: response.result.seller_token,
									info: response.result.seller_info
								})
							}
							// 存在链接，跳转回去
							if (this.redirecturl) {
								this.redirecturl = decodeURIComponent(this.redirecturl)
								window.location.href = this.redirecturl;
								return;
							} else {
								if (this.loginurl) {
									//判断是否在微信打开
									var ua = navigator.userAgent.toLowerCase();
									if (ua.match(/MicroMessenger/i) == "micromessenger") {
										window.location.href = this.loginurl + "&login=1";
									} else {
										var urls = this.loginurl + "&login=1";
										var titles = "Register"
										this.$router.push({
											name: 'HomePage',
											query: {
												urls: urls,
												titles: titles
											}
										})
									}
									//判断是否在微信打开 end
								} else {
									this.goHome()
								}
							}

						},
						error => {
							Indicator.close()
							Toast(error.message)
						}
					)
				} else {
					let mobileusername = this.mobileusername
					if (mobileusername.length != 11) {
						Toast('请输入11位手机号')
						return
					}
					Indicator.open()
					LoginByMobile(mobileusername, this.code).then(
						response => {
							Indicator.close()
							this.saveAuthInfo({
								token: response.result.token,
								info: response.result.info
							})
							if (response.result.seller_info) {
								this.saveSellerAuthInfo({
									token: response.result.seller_token,
									info: response.result.seller_info
								})
							}
							if (this.loginurl) {
								//判断是否在微信打开
								var ua = navigator.userAgent.toLowerCase();
								if (ua.match(/MicroMessenger/i) == "micromessenger") {
									window.location.href = this.loginurl + "&login=1";
								} else {
									var urls = this.loginurl + "&login=1";
									var titles = "观众预登记"
									this.$router.push({
										name: 'HomePage',
										query: {
											urls: urls,
											titles: titles
										}
									})
								}
								//判断是否在微信打开 end
							} else {
								this.goHome()
							}
						},
						error => {
							Indicator.close()
							Toast(error.message)
						}
					)
				}
			},

			goBack() {
				let isFromInfoEdit = this.$route.params.isFromInfoEdit
				let isFromShare = this.$route.params.isFromShare
				if (isFromInfoEdit || isFromShare) {
					this.$router.push('home')
				} else {
					this.$router.go((this.$route.query.clear) ? -2 : -1)
				}
			},

			goHome() {
				let referrer = this.getReferrer()

				if (referrer) { // 返回之前的页面
					referrer = decodeURIComponent(referrer)
					this.utils.clearCookie('referrer')
					this.$router.push({
						path: referrer
					})
				} else {
					this.$router.push({
						name: 'MemberIndex'
					})
				}
			},
			getReferrer() {
				let referrer = this.$route.query.referrer
				if (!referrer) {
					referrer = this.utils.getCookie('referrer')
				}
				if (referrer && (referrer.search('memberlogin') != -1 || referrer.search('memberregister') != -1 || referrer
						.search('memberbind') != -1)) {
					referrer = env.H5_HOST + '/member/index'
				}
				return referrer
			},
			onSignup() {
				this.$router.push({
					name: 'HomeMemberRegister'
				})
			},

			onRetrieve() {
				this.$router.push({
					name: 'HomeMemberForget'
				})
			},

			onWechat() {
				if (!this.ifLoaded) {
					Toast('请等待文件加载完成')
					return
				}
				let _this = this
				uni.getEnv(function(res) {
					if (res.plus) {
						_this.uniapp = 1
					}
				})
				let referrer = this.getReferrer()
				if (referrer) { // 返回之前的页面
					referrer = decodeURIComponent(referrer)
				}
				if (this.uniapp) {
					uni.redirectTo({
						url: 'login?inviter_id=' + this.inviter_id + '&ret_url=' + encodeURIComponent(referrer)
					})
					return
				}
				let ref = encodeURIComponent(referrer)

				var clear = this.$route.query.clear;
				var type = this.$route.query.type;
				var appintment = this.$route.query.appintment;
				var member_id = this.$route.query.member_id;
				var live_apply_id = this.$route.query.live_apply_id;
				var live_apply_play_time = this.$route.query.live_apply_play_time;

				wechatLogin(ref, this.inviter_id, clear, type, appintment, member_id, live_apply_id, live_apply_play_time)
					.then(res => {
						window.location.href = res.result
					}).catch(function(error) {
						Toast(error.message)
					})
			}

		}
	}
</script>

<style scoped lang='scss'>
	#app {
		background: #fff;
	}

	.routineloginBox {
		background: #fff;
	}

	.wxcodebox {
		background: #fff;
		height: 100%;
		position: absolute;
		z-index: 10;
		left: 0;
		top: 0;
		width: 100%;
	}

	.dypligobox {
		text-align: center;
		padding: 3rem 0;
		padding-top: 7rem;
	}

	.dypligobox img {
		width: 90%;
		max-width: 10rem;
	}

	.loginbottomBox {
		text-align: center;
		padding: 0 1rem;
	}

	.wxloginbottom {
		background: #51a938;
		color: #fff;
		font-size: 0.8rem;
		padding: 0.5rem 02rem;
		border-radius: 5px;
		display: inline-block;
		width: 90%;
		max-width: 10rem;
		letter-spacing: 1px;
	}

	.phoneloginbottom {
		background: #fff;
		color: #777;
		font-size: 0.8rem;
		padding: 0.5rem 02rem;
		border-radius: 5px;
		display: inline-block;
		width: 90%;
		max-width: 10rem;
		letter-spacing: 1px;
		border: 1px solid #ccc;
		margin-top: 0.8rem;
	}

	.wxloginbottom img {
		width: 1.1rem;
		display: inline-block;
		margin-right: 3px;
	}

	.container {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		background-color: #F0F2F5;

		.countdown {
			min-width: 4rem;
			margin-right: 0.5rem;
		}

		.top-wrapper {
			.input-wrapper {
				display: flex;
				align-content: center;
				align-items: center;
				padding-left: 0.4rem;
				background-color: #fff;
				height: 2.2rem;

				img {
					height: 1.75rem;
					width: auto;
					margin: 0;
					padding: 0;
				}

				input {
					flex: 1;
					font-size: .8rem;
				}

				.bottom-input {
					border-bottom-width: 0;
				}
			}
		}
	}

	.retrieve-wrapper {
		height: 2rem;
		margin-top: 0.4rem;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
	}

	.retrieve-item {
		width: 8rem;
		height: 2rem;
		margin-right: 0.4rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#retrieve-title {
		color: $primaryColor;
		font-size: 0.75rem;
		text-align: center;
	}

	.bottom-wrapper {
		display: flex;
		flex: 1;
		flex-direction: column;
		justify-content: flex-end;
		align-items: stretch;
	}

	.auth-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		height: 13rem;
	}

	.auth-title-wrapper {
		height: 1rem;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 2rem;
	}

	.auth-title {
		color: #999999;
		font-size: 0.7rem;
	}

	.auth-line {
		display: flex;
		flex: 1;
		height: 1px;
		background-color: #d8d8d8;
		margin-left: 0.8rem;
		margin-right: 0.8rem;
	}

	.auth-item {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	}

	.auth-item-icon {
		width: 3rem;
		height: 3rem;
		text-align: center;
		font-size: 3rem;

	}

	.wechat {
		color: #2db304;
	}

	.sina {
		color: #f01414;
	}

	.tencent {
		color: #26a2ff;
	}

	.auth-item-title {
		margin-top: 0.6rem;
	}

	.auth-bottom-wrapper {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		margin-left: 0.75rem;
		margin-right: 0.75rem;
		margin-bottom: 1rem;
	}

	.topList {
		height: 2rem;
		border-bottom: 1px solid #e8eaed;

		.list {
			height: 100%;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-content: center;
			align-items: stretch;
			background-color: #fff;
		}

		.item {
			flex: 1;
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}

		.title {
			text-align: center;
			font-size: 0.8rem;
			color: #404245;
		}

		.active {
			color: $primaryColor;
		}

		.normal {
			color: #404245;
		}

		.line {
			position: absolute;
			left: 2.5rem;
			right: 2.5rem;
			bottom: 0;
			height: 0.1rem;
			background-color: #e93b3d;
		}
	}

	.top-wrapper {
		margin-top: 0.4rem;
	}
</style>